import { combineReducers } from 'redux'
import login from './login'
import citationReducer from './citationReducer'

export default combineReducers({
	login,
	citationReducer
})
